import { Injectable, Injector } from '@angular/core';
import { appInjector } from '@max/shared/app-injector';
import { BusinessTransactionService } from '@max/shared/services/business-transaction/business-transaction.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TransactionApiActions, TransactionQueueActions } from './actions';

@Injectable()
export class TransactionEffects {
    private businessTransactionService: BusinessTransactionService;

    constructor(
        private actions$: Actions,
        private injector: Injector) {
        appInjector(this.injector);
        this.businessTransactionService = this.injector.get(BusinessTransactionService);
    }

    loadUsers$ = createEffect(
        () => this.actions$.pipe(
            ofType(TransactionQueueActions.loadUsers),
            mergeMap(() => this.businessTransactionService.getBusinessUnitUsers().pipe(
                map(response => response.result),
                map(users => TransactionApiActions.loadUsersSuccess({ users })),
                catchError(error => of(TransactionApiActions.loadUsersFailure({ error })))
            ))
        )
    );
}
